/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import NeoButtonSection from "design/design_components/neo/layout/NeoButtonSection.base";
import NeoButtonMain from "design/design_components/neo/button/NeoButtonMain.base";
import FormularioSeleccionarTipoPagoModal from "components/common/FormularioSeleccionarTipoPagoModal";
import { ORDEN } from 'consts/db.const';

const BotonPagarOrden = (props) => {
    const [mostrarTiposPagos, setMostrarTiposPagos] = useState(false);

    return (props?.orden?.orden_pago_estado_id === ORDEN.PAGO.PENDIENTE.ID &&
    <>
            <FormularioSeleccionarTipoPagoModal
                muestraModal={mostrarTiposPagos}
                setMuestraModal={(mostrar) => setMostrarTiposPagos(mostrar)}
                checkoutTDC={props.checkoutTDC}
                obtieneCuentaClabeSTP={props.obtieneCuentaClabeSTP}
                orden={props.orden}
            />
            <NeoButtonSection align="right">
                <NeoButtonMain
                    label="Pagar orden"
                    onClick={() => setMostrarTiposPagos(true)}
                />
            </NeoButtonSection>
    </>
    )
}

export default BotonPagarOrden;